module.exports = __webpack_public_path__ + "static/media/50.494b3f84.png";